import { Injector } from '@angular/core';
import { GameStateId } from '../../state/game/game.state';
import { TournamentGameServer } from './base/tournament-game-server.class';

export class SngGameServer extends TournamentGameServer {

    constructor(
        protected url: string, protected gameStateId: GameStateId, protected injector: Injector
    ) {
        super();
        this.init();
    }

    protected injectServices() {
        super.injectServices();
    }

    listenToMessages() {
        super.listenToMessages();
    }

    protected stopListeningToMessages() {
        super.stopListeningToMessages();
    }
}
